import React__default from 'react';
import { Body } from '../Typography/index.es.js';
import styled from '@emotion/styled';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getColor = (props) => {
  var _a, _b, _c, _d;
  if (props.disabled) {
    if (props.checked)
      return (_a = props.theme) == null ? void 0 : _a.colors.primary100;
    return (_b = props.theme) == null ? void 0 : _b.colors.divider;
  } else {
    if (props.checked)
      return (_c = props.theme) == null ? void 0 : _c.colors.primary500;
    return (_d = props.theme) == null ? void 0 : _d.colors.border;
  }
};
const Radio = (_a) => {
  var _b = _a, {
    checked,
    disabled,
    onChange,
    children
  } = _b, rest = __objRest(_b, [
    "checked",
    "disabled",
    "onChange",
    "children"
  ]);
  return /* @__PURE__ */ React__default.createElement(StyledWrapper, __spreadValues({}, rest), /* @__PURE__ */ React__default.createElement(StyledRadio, null, /* @__PURE__ */ React__default.createElement(StyledInput, {
    type: "radio",
    checked,
    disabled: !!disabled,
    onChange: (e) => !disabled && onChange && onChange(e.target.checked),
    className: "teko-radio-input"
  }), /* @__PURE__ */ React__default.createElement(RadioInner, {
    checked,
    disabled,
    className: "radio-inner"
  }, /* @__PURE__ */ React__default.createElement(RadioChecked, {
    checked,
    disabled
  }))), !!children && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, typeof children === "string" ? /* @__PURE__ */ React__default.createElement(Body, {
    level: 1,
    weight: "regular",
    style: { flex: 1 }
  }, children) : children));
};
const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
const RadioChecked = styled.div`
  position: absolute;
  width: 50%;
  height: 50%;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: ${(p) => p.checked ? "block" : "none"};
  background-color: ${(p) => p.disabled ? p.theme.colors.primary100 : p.theme.colors.primary500};
`;
const StyledRadio = styled.div`
  display: inline-block;
  position: relative;
  width: 16px;
  min-width: 16px;
  height: 16px;
  margin-right: 8px;
`;
const RadioInner = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid ${(p) => getColor(p)};
  border-radius: 50%;
  background-color: ${(p) => p.disabled && !p.checked ? p.theme.colors.background : p.theme.colors.white};
`;
const StyledInput = styled.input(({
  disabled,
  checked,
  theme
}) => `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: ${disabled ? "not-allowed" : "pointer"};
  opacity: 0;
  ${!disabled && !checked ? `
      &:hover + .radio-inner {
        border-color: ${theme == null ? void 0 : theme.colors.placeholder};
      }
    ` : ""}
`);

export { Radio };
